/**
 * User: n.gorte
 * Date: 17.09.2020
 * Time: 16:49
 */

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { Table } from 'external/react-bootstrap';
import { getEventType } from '../../utils/event-type-util';
import { EVENT_TYPE_CREATE, EVENT_TYPE_DELETE, EVENT_TYPE_UPDATE } from '../../constants/Constants';

export const DefaultChangeRecordTable = ({ changeRecord, children }) => {
    const eventType = getEventType(changeRecord);

    return (
        <Table
            className="change-records-table"
            responsive bordered size="sm"
        >
            <thead className="change-records-table__head">
            <tr>
                <th className="change-records-table__first-col">Eigenschaft</th>
                {
                    eventType === EVENT_TYPE_UPDATE &&
                    <th className="change-records-table__old-value">Alt</th>
                }
                {
                    eventType === EVENT_TYPE_DELETE &&
                    <th className="change-records-table__old-value">Gelöscht</th>
                }
                {
                    eventType !== EVENT_TYPE_DELETE &&
                    <th className="change-records-table__new-value">{eventType === EVENT_TYPE_CREATE ? 'Erstellt' : 'Neu'}</th>
                }
            </tr>
            </thead>
            <tbody>
            {children}
            </tbody>
        </Table>
    );
};

DefaultChangeRecordTable.propTypes = {
    changeRecord: PropTypes.object,
};



// WEBPACK FOOTER //
// ./js/components/ChangeRecords/DefaultChangeRecordTable.jsx